import { ApiService } from './apiService';

// ─── Types ───────────────────────────────────────────────────────────────────

export interface TaliaChatMessage {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  createdAt: string;
  // The store products the reply shows, as the search's cards are made from.
  products: any[];
}

export interface TaliaReply {
  id: string;
  responseText: string;
  products: any[];
}

// ─── Service ─────────────────────────────────────────────────────────────────

// Talia as a shopper would meet her, under the admin's own user and uncharged.
// Messages come back newest first.
export const getTaliaChatMessages = async (page: number, size: number): Promise<TaliaChatMessage[]> => {
  return await ApiService.get(`talia-chat?page=${page}&size=${size}`);
};

export const sendTaliaChatMessage = async (message: string): Promise<TaliaReply> => {
  return await ApiService.post('talia-chat', { message });
};

export const clearTaliaChat = async () => {
  return await ApiService.delete('talia-chat');
};
